export class ResellerCodeValidationResult {
  isValid: boolean

  resellerName?: string

  errorMessage?: string

  constructor(data: Partial<ResellerCodeValidationResult> = {}) {
    this.isValid = data.isValid ?? false

    this.resellerName = data.resellerName

    this.errorMessage = data.errorMessage
  }
}
